import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router';
import { api, type PutAwayRowData } from '../../api';
import { canWrite, useAuth } from '../../auth';
import { number } from '../../ui';

const tile = 'flex min-h-24 flex-col justify-center rounded-xl bg-white p-4 shadow-sm ring-1 ring-slate-200 active:bg-slate-100';

export function MobileHome() {
  const { user } = useAuth();
  const writer = canWrite(user);
  const waiting = useQuery({
    queryKey: ['put-away', null],
    enabled: writer,
    queryFn: () => api<{ rows: PutAwayRowData[]; total: number }>('/api/v1/put-away'),
  });
  return (
    <div className="space-y-3">
      <h1 className="text-xl font-semibold">Hello {user?.name}</h1>
      {writer && (
        <Link to="/m/scan" className={tile}>
          <span className="text-lg font-semibold">Scan a part to add it</span>
          <span className="text-sm text-slate-600">Take a photo, check the part and colour, pick the bin.</span>
        </Link>
      )}
      {writer && (
        <Link to="/m/put-away" className={tile}>
          <span className="text-lg font-semibold">Put away{waiting.data ? ` (${number(waiting.data.total)} waiting)` : ''}</span>
          <span className="text-sm text-slate-600">Stock that has arrived and has no bin yet, one part at a time.</span>
        </Link>
      )}
      <Link to="/m/find" className={tile}>
        <span className="text-lg font-semibold">Find a part or a bin</span>
        <span className="text-sm text-slate-600">Where is it, and how many are there?</span>
      </Link>
      <Link to="/stocktaking" className={tile}>
        <span className="text-lg font-semibold">Count stock</span>
        <span className="text-sm text-slate-600">Opens the stocktaking screens.</span>
      </Link>
    </div>
  );
}
